<template>
    <div style="width: 100%;">
        <v-row style="padding: .1rem 5rem 1rem 5rem;">
            <v-col cols="12" lg="6" md="6">
                <v-row><span style="font-weight: 600;margin-bottom:.4rem ;">Condición de Ingreso</span></v-row>
                <v-row style="padding: 0rem 0rem 0rem 1rem; width: 100%;">
                    <el-select v-model="grupo1" multiple placeholder="Select" style="width: 70%;">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </v-row>
            </v-col>
            <v-col cols="12" lg="6" md="6">
                <v-row><span style="font-weight: 600;margin-bottom:.4rem ;">Tipo</span></v-row>
                <v-row style="padding: 0rem 0rem 0rem 1rem; width: 100%;">
                    <el-select v-model="grupo2" multiple placeholder="Select" style="width: 70%;">
                        <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </v-row>
            </v-col>
        </v-row>
        <v-row style="padding: 1rem 5rem .5rem 5rem; width: 100%;">
            <el-form label-width="90px" size="mini" style="width: 100%">
                <v-row style="padding:0rem  1rem">
                    <v-col cols="12" lg="6" style="display: flex ; text-align: center; justify-content: center;">
                        <table>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Horario</th>
                                    <th>Guardia</th>
                                    <th>Jefe</th>
                                    <th>Tipo</th>
                                    <th>HE 25%</th>
                                    <th>HE 35%</th>
                                    <th>Feriado</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, i) in mitad1" :key="i">
                                    <td> <span>{{ item.nombre_dia.slice(0, 3) + ' ' + item.numero_dia }}</span></td>
                                    <td> <el-input v-model="item.horas_horario" autocomplete="off"
                                            style=" width: 5.2rem;" size="mini"
                                            @input="formatearHoras(item, 'horas_horario')"
                                            @keydown.native="detectarBorrado($event, item, 'horas_horario')"></el-input>
                                    </td>
                                    <td> <el-input v-model="item.horas_guardia" autocomplete="off" size="mini"
                                            style="margin: 0 .2rem; width: 5.2rem;"
                                            @input="formatearHoras(item, 'horas_guardia')"
                                            @keydown.native="detectarBorrado($event, item, 'horas_guardia')"></el-input>
                                    </td>
                                    <td> <el-checkbox v-model="item.es_jefe" size="mini"></el-checkbox></td>
                                    <td> <el-input v-model="item.tipo" autocomplete="off" size="mini"
                                            style="margin: 0 .2rem; width: 2rem;"></el-input></td>
                                    <td> <el-input v-model="item.he_25" @input="calcularHorasExtrasHE25(item)"
                                            size="mini" style="margin: 0 .2rem; width: 2rem;"></el-input>
                                    </td>
                                    <td> <el-input v-model="item.he_35" @input="calcularHorasExtrasHE35(item)"
                                            size="mini" style="margin: 0 .2rem; width: 2rem;"></el-input>
                                    </td>
                                    <td>
                                        <el-checkbox v-model="item.es_feriado" size="mini" disabled></el-checkbox>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-col>
                    <v-col cols="12" lg="6" style="display: flex ; text-align: center; justify-content: center;">
                        <table>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Horario</th>
                                    <th>Guardia</th>
                                    <th>Jefe</th>
                                    <th>Tipo</th>
                                    <th>HE 25%</th>
                                    <th>HE 35%</th>
                                    <th>Feriado</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, i) in mitad2" :key="i">
                                    <td> <span>{{ item.nombre_dia.slice(0, 3) + ' ' + item.numero_dia }}</span></td>
                                    <td> <el-input v-model="item.horas_horario" autocomplete="off"
                                            style=" width: 5.2rem;" size="mini"
                                            @input="formatearHoras(item, 'horas_horario')"
                                            @keydown.native="detectarBorrado($event, item, 'horas_horario')"></el-input>
                                    </td>
                                    <td> <el-input v-model="item.horas_guardia" autocomplete="off" size="mini"
                                            style="margin: 0 .2rem; width: 5.2rem;"
                                            @input="formatearHoras(item, 'horas_guardia')"
                                            @keydown.native="detectarBorrado($event, item, 'horas_guardia')"></el-input>
                                    </td>
                                    <td> <el-checkbox v-model="item.es_jefe" size="mini"></el-checkbox></td>
                                    <td> <el-input v-model="item.tipo" autocomplete="off" size="mini"
                                            style="margin: 0 .2rem; width: 2rem;"></el-input></td>
                                    <td> <el-input v-model="item.he_25" autocomplete="off" size="mini"
                                            style="margin: 0 .2rem; width: 2rem;" @input="calcularHorasExtrasHE25(item)"></el-input></td>
                                    <td> <el-input v-model="item.he_35" autocomplete="off" size="mini"
                                            style="margin: 0 .2rem; width: 2rem;" @input="calcularHorasExtrasHE35(item)"></el-input></td>
                                    <td> <el-checkbox v-model="item.es_feriado" size="mini" disabled></el-checkbox></td>
                                </tr>
                            </tbody>
                        </table>
                    </v-col>
                </v-row>
                <el-skeleton v-if="dialogLoader" :rows="13" animated />
            </el-form>
        </v-row>
        <v-row style="padding: 1rem 0rem .5rem 5rem;">
            <v-col>
                <v-row>
                    <span style="font-weight: 600;">Horas Asistenciales : </span> {{ this.totalHorasAsistenciales }}
                </v-row>
                <v-row>
                    <span style="font-weight: 600;">Horas Extras : </span> {{ this.totalHorasExtra }}
                </v-row>
                <v-row>
                    <span style="font-weight: 600;">Total Horas : </span> {{ this.horasTotales }}
                </v-row>
            </v-col>
        </v-row>
        <span slot="footer" class="dialog-footer" style="display: flex; justify-content: end;">
            <el-button @click="closeEdit">Cancelar</el-button>
            <el-button type="primary" @click="save" v-if="nuevoHorarioPersonal">Confirmar</el-button>
            <el-button type="primary" @click="edit" v-if="!nuevoHorarioPersonal">Guardar</el-button>
        </span>
        <v-dialog v-model="dialogLoader" persistent width="300" style="padding: 1rem;overflow: hidden !important;"
            class="loading-loader">
            <v-progress-circular :size="80" color="primary" :width="5" indeterminate></v-progress-circular>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
export default {
    props: ["periodoActual"],
    data() {
        return {
            options: [{ value: 0, label: "D.L. 278" }, { value: 1, label: "D.L. 276" }, { value: 2, label: "C.A.S." }, { value: 3, label: "Practicante" }],
            options1: [{ value: 0, label: "Administrativos" }, { value: 1, label: "Asistencial" }],
            grupo1: [], // Aquí se guardan las opciones seleccionadas del primer grupo
            grupo2: [],
            dialogLoader: false,
            dataPaciente: [],
            nuevoHorarioPersonal: false,
            totalHorasAsistenciales: 0,
            totalHorasExtra: 0,
            horasTotales: 0,
            dataPersonal: [],
            totalHorarioSuma: 0,
            totalGuardiaSuma: 0
        };
    },
    watch: {},
    methods: {
        detectarBorrado(event, item, campo) {
            // Backspace = 8, Delete = 46
            if (event.key === 'Backspace' || event.key === 'Delete') {
                console.log('Se presionó borrar');
                item[campo] = "";
                this.calcularHoras(campo);
                // Puedes agregar lógica personalizada aquí si lo necesitas
            }
        },
        save() {
            this.dialogLoader = true;
            for (let index = 0; index < this.dataPaciente.length; index++) {
                const element = this.dataPaciente[index];
                axios
                    .post(RUTA_API + "/rrhh_planilla_dias_horario/", element)
                    .then((res) => {
                        if (this.dataPaciente.length == index + 1) {
                            this.dialogLoader = false;
                            this.closeEdit();
                            Swal.fire({
                                title: "¡Exito!",
                                text: "¡Se grabó correctamente!",
                                icon: "success",
                                confirmButtonText: "Aceptar"
                            });
                        };
                    })
                    .catch((res) => {
                        console.log("Error:", res);
                    });
            }
        },
        edit() {
            this.dialogLoader = true;
            for (let index = 0; index < this.dataPaciente.length; index++) {
                const element = this.dataPaciente[index];
                axios
                    .patch(RUTA_API + "/rrhh_planilla_dias_horario/" + element.id + "/", element)
                    .then((res) => {
                        this.closeEdit();
                        if (this.dataPaciente.length == index + 1) {
                            this.dialogLoader = false;
                            Swal.fire({
                                title: "¡Exito!",
                                text: "¡Se editó correctamente!",
                                icon: "success",
                                confirmButtonText: "Aceptar"
                            });
                        };
                    })
                    .catch((res) => {
                        console.log("Error:", res);
                    });
            }
        },
        /* formatearHoras(item) {
            const raw = item.horas_horario.replace(/[^0-9]/g, '').slice(0, 8); // Solo números, máx 8 caracteres

            if (raw.length === 2) {
                const h1 = raw.slice(0, 2);
                item.horas_horario = `${h1}:`;
            }
            if (raw.length === 4) {
                const h1 = raw.slice(0, 2);
                const m1 = raw.slice(2, 4);
                item.horas_horario = `${h1}:${m1} A `;
            }
            if (raw.length === 6) {
                const h1 = raw.slice(0, 2);
                const m1 = raw.slice(2, 4);
                const h2 = raw.slice(4, 6);
                item.horas_horario = `${h1}:${m1} A ${h2}:`;
            }
            if (raw.length === 8) {
                const h1 = raw.slice(0, 2);
                const m1 = raw.slice(2, 4);
                const h2 = raw.slice(4, 6);
                const m2 = raw.slice(6, 8);
                item.horas_horario = `${h1}:${m1} A ${h2}:${m2}`;
                this.calcularHoras();
            }

            if (raw.length === 0) {
                this.calcularHoras();
            }
        }, */
        formatearHoras(item, campo) {
            const raw = item[campo].replace(/[^0-9]/g, '').slice(0, 8); // Solo números, máx 8 caracteres

            if (raw.length === 2) {
                const h1 = raw.slice(0, 2);
                item[campo] = `${h1}:`;
            } else if (raw.length === 4) {
                const h1 = raw.slice(0, 2);
                const m1 = raw.slice(2, 4);
                item[campo] = `${h1}:${m1} A `;
            } else if (raw.length === 6) {
                const h1 = raw.slice(0, 2);
                const m1 = raw.slice(2, 4);
                const h2 = raw.slice(4, 6);
                item[campo] = `${h1}:${m1} A ${h2}:`;
            } else if (raw.length === 8) {
                const h1 = raw.slice(0, 2);
                const m1 = raw.slice(2, 4);
                const h2 = raw.slice(4, 6);
                const m2 = raw.slice(6, 8);
                item[campo] = `${h1}:${m1} A ${h2}:${m2}`;
                this.calcularHoras(campo);
            }

            if (raw.length === 0) {
                this.calcularHoras(campo);
            }
        },
        calcularHorasExtrasHE25(item) {
            if (item.he_25.slice(0, 1) == 0) {
                item.he_25 = item.he_25.slice(1, 2);
            }
            if (item.he_25 == '') {
                item.he_25 = 0;
            }
            this.totalHorasExtra = this.dataPaciente.reduce((total, item) => {
                return total + Number(item.he_25 || 0) + Number(item.he_35 || 0); // aseguras que es número
            }, 0);
            this.horasTotales = this.totalHorasExtra + this.totalHorasAsistenciales;
        },
        calcularHorasExtrasHE35(item) {
            if (item.he_35.slice(0, 1) == 0) {
                item.he_35 = item.he_35.slice(1, 2);
            }
            if (item.he_35 == '') {
                item.he_35 = 0;
            }
            this.totalHorasExtra = this.dataPaciente.reduce((total, item) => {
                return total + Number(item.he_35 || 0) + Number(item.he_25 || 0); // aseguras que es número
            }, 0);
            this.horasTotales = this.totalHorasExtra + this.totalHorasAsistenciales;
        },
        calcularHoras(nombreItem) {
            const totalSuma = this.dataPaciente.reduce((total, item) => {
                if (!item[nombreItem] || !item[nombreItem].includes(" A ")) return total;

                const [inicio, fin] = item[nombreItem].split(" A ");
                const [hInicio, mInicio] = inicio.split(":").map(Number);
                const [hFin, mFin] = fin.split(":").map(Number);

                if (isNaN(hInicio) || isNaN(mInicio) || isNaN(hFin) || isNaN(mFin)) return total;

                const inicioMin = hInicio * 60 + mInicio;
                const finMin = hFin * 60 + mFin;

                const diferencia = finMin - inicioMin;
                const horas = diferencia / 60;

                return total + (horas > 0 ? horas : 0); // suma solo si es positivo
            }, 0);

            if (nombreItem == 'horas_horario') {
                this.totalHorarioSuma = totalSuma;
            } else {
                this.totalGuardiaSuma = totalSuma;
            }

            this.totalHorasAsistenciales = this.totalHorarioSuma + this.totalGuardiaSuma;
            this.horasTotales = Number(this.totalHorasExtra || 0) + this.totalHorasAsistenciales;
        },
        nuevoHorario() {
            this.dialogLoader = true;
            axios
                .get(RUTA_API + "/rrhh_planilla_dias/periodo/?periodo=" + this.periodoActual)
                .then((res) => {
                    this.dataPaciente = res.data;
                    this.dataPaciente = this.dataPaciente.map(dia => ({
                        ...dia,
                        dias_id: dia.id,
                        horas_guardia: '',
                        horas_horario: '',
                        rango_horario: '',
                        rango_guardia: '',
                        tipo: '',
                        he_25: '',
                        he_35: '',
                        es_jefe: false,
                        personal_id: "item"
                    }));
                    this.dialogLoader = false;
                })
                .catch((res) => {
                    console.log("Error:", res);
                });
        },
        loadPersonal() {
            this.dialogLoader = true;
            axios
                .get(RUTA_API + "/rrhh_planilla_personal/?estado=true&campos=id,estado,nombre_completo,cod_planilla,cond_ingreso,cargo,descripcion_cargo", {
                    headers: { Authorization: this.auth },
                })
                .then((res) => {
                    this.dataPersonal = res.data;
                    this.nuevoHorario();
                })
                .catch((res) => {
                    this.dialogLoader = false;
                });
        },
        closeEdit() {
            this.$emit('closeDialogCargaMasiva');
        },
        submitForm() {
        }
    },
    mounted() { },
    computed: {
        filteredHeaders() {
            return this.headers;
        },
        mitad1() {
            const total = this.dataPaciente.length;
            const mitad = Math.ceil(total / 2);
            return this.dataPaciente.slice(0, mitad);
        },
        mitad2() {
            const total = this.dataPaciente.length;
            const mitad = Math.ceil(total / 2);
            return this.dataPaciente.slice(mitad, total);
        }

    },
    created() {
        this.loadPersonal();
    },
    components: {},
};
</script>
<style scoped>
::v-deep .v-overlay__scrim {
    opacity: 0.5 !important;
    background-color: rgba(203, 25, 25, 0.54) !important;
    border-color: rgb(255 255 255) !important;
}

::v-deep .v-overlay {
    z-index: 99 !important;
}

::v-deep .loading-loader {
    z-index: 99 !important;
}

::v-deep .v-dialog {
    display: flex;
    justify-content: center;
    box-shadow: none;
    overflow-y: hidden !important;
}

::v-deep .el-form-item__label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #606266;
    /* line-height: 40px !important; */
    line-height: 28px !important;
    margin-left: 0 !important;
    padding: 0 12px 0 0;
    box-sizing: border-box;
}

::v-deep .el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
    margin-bottom: 7px !important;
}

::v-deep .el-dialog__body {
    padding: 0px !important;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

::v-deep .col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
    width: 100%;
    padding: 0px;
}

::v-deep .el-input--mini .el-input__inner {
    height: 28px;
    line-height: 28px;
    text-align: center;
    padding: .2rem;
}

::v-deep tr td {
    text-wrap: nowrap !important;
    padding: .05rem .2rem !important;
}
</style>